import * as React from 'react';
import { Link } from 'react-router-dom';
import { Groups } from '../../../Enum/Groups';
import { FilterInterface } from '../../../Filter/FilterInterface';
import { ProductInterface } from '../../../Model/Product';
import { FilterService } from '../../../Service/FilterService';
import { Trans } from '../../Trans';
import { AbstractFinder, FinderProps } from '../AbstractFinder';

export interface ElectronicsFinderProps extends FinderProps {
}

export class ElectronicsFinder extends AbstractFinder<ElectronicsFinderProps> {
    get group(): Groups {
        return Groups.Electronics;
    }

    protected renderHeadline(filteredProducts: ProductInterface[], allProducts: ProductInterface[]): JSX.Element {
        return <h1>
            <Link to="/">Home</Link> &gt; <Trans>Measuring Roller</Trans>
        </h1>;
    }

    protected getInitialFilters(): FilterInterface<any>[] {
        return [
            FilterService.oneOf('Feldbus', [], false),
            FilterService.equals('Anzahl_Messrollen', '', false), // Alternative: FilterService.range('Anzahl_Messrollen', RangeFilterValue.empty(), false),
            FilterService.boolean('eichfaehig', false, false),
        ];
    }

    protected collectProducts(rootProducts: ProductInterface[]): ProductInterface[] {
        return rootProducts;
    }
}
